import { apiUrl } from '../config';
import { readApiJson } from './apiResponse';
import { userHasSignupBusinessData } from './businessProfile';

export async function loginWithGoogleCredential(credential) {
  const res = await fetch(apiUrl('/api/auth/google'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential }),
  });

  const data = await readApiJson(res);

  if (!res.ok) {
    throw new Error(data.message || 'Error al autenticar con Google');
  }

  return data;
}

export function isSuperAdminUser(user) {
  return user?.role === 'admin' && user?.isSuperAdmin === true;
}

/**
 * Devuelve true si el usuario necesita completar el onboarding
 * (elegir plan, cargar empresa/fiscal).
 * Para login: false si el usuario ya tiene plan y perfil completo.
 * Para registro: siempre true si isNewUser o needsOnboarding.
 */
export function shouldCompleteProfile(user, { isNewUser = false, needsOnboarding = false } = {}) {
  if (isSuperAdminUser(user)) return false;
  if (isNewUser || needsOnboarding) return true;
  if (!user) return true;
  const hasBusinessProfile = userHasSignupBusinessData(user);
  if (user.subscription?.profileCompleted === false && !hasBusinessProfile) return true;
  const plan = user.currentPlan;
  if (!plan) return true;
  if (typeof plan === 'object' && !plan.id && !plan._id) return true;
  return false;
}

const GOOGLE_ONBOARDING_KEY = 'googleOnboardingSession';

/** Guardar sesión temporal mientras el usuario completa el registro (sin loguear aún). */
export function storeGoogleOnboardingSession(data) {
  if (!data?.token && !data?.googleSignupToken) return;
  sessionStorage.setItem(
    GOOGLE_ONBOARDING_KEY,
    JSON.stringify({
      user: data.user,
      token: data.token || null,
      refreshToken: data.refreshToken || null,
      googleSignupToken: data.googleSignupToken || null,
    })
  );
}

export function loadGoogleOnboardingSession() {
  try {
    const raw = sessionStorage.getItem(GOOGLE_ONBOARDING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearGoogleOnboardingSession() {
  sessionStorage.removeItem(GOOGLE_ONBOARDING_KEY);
}
